import { GoalType } from '@griply/types';
import { Paths } from 'shared/routes/paths';
import { Goal } from 'shared/types/goal';
import { getGoalDetailUrl } from 'shared/utils/get-goal-detail-url';

const summaryPaths: Paths[] = [Paths.GoalDetail, Paths.ProjectDetail];

// A project has a single surface; its other routes exist only to redirect.
export const getProjectRedirectUrl = (
  goal: (Pick<Goal, 'id'> & Partial<Pick<Goal, 'type'>>) | undefined,
  activePath: Paths | undefined,
): string | null => {
  if (goal?.type !== GoalType.Project) {
    return null;
  }

  if (!activePath || summaryPaths.includes(activePath)) {
    return null;
  }

  return getGoalDetailUrl(goal);
};
